module.exports = __webpack_public_path__ + "static/media/truck-bfull.6946121c.svg";